import React, { useEffect, useRef, useState } from "react";

const AnimatedCounter = ({
  end,
  duration = 2000,
  suffix = "",
  prefix = "",
  className = "",
}) => {
  const [count, setCount] = useState(0);

  const counterRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const element = counterRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Start animation once
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;

          let startTimestamp = null;

          const step = (timestamp) => {
            if (!startTimestamp) {
              startTimestamp = timestamp;
            }

            const progress = Math.min(
              (timestamp - startTimestamp) / duration,
              1
            );

            const currentCount = Math.floor(progress * end);

            setCount(currentCount);

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              setCount(end);
            }
          };

          requestAnimationFrame(step);

          observer.unobserve(element);
        }
      },
      {
        threshold: 0.3,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [end, duration]);

  return (
    <span
      ref={counterRef}
      className={className}
      aria-label={`${prefix}${end}${suffix}`}
      aria-live="polite"
    >
      {prefix}
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};

export default AnimatedCounter;